import { z } from 'zod';

export const addressSchema = z.object({
  street: z.string().min(1, 'Obrigatório'),
  number: z.string().min(1, 'Obrigatório'),
  neighborhood: z.string().min(1, 'Obrigatório'),
  city: z.object(
    {
      label: z.string(),
      value: z.coerce.number({ message: 'Obrigatório' }),
    },
    { required_error: 'Obrigatório', invalid_type_error: 'Obrigatório' },
  ),
  state: z.object(
    {
      label: z.string(),
      value: z.coerce.number({ message: 'Obrigatório' }),
    },
    { required_error: 'Obrigatório', invalid_type_error: 'Obrigatório' },
  ),
  zipCode: z
    .string()
    .default('')
    .refine(
      (value) => {
        const regex = /^\d{5}-\d{3}$/;
        return regex.test(value);
      },
      {
        message: 'Informe um CEP válido',
      },
    ),
  complement: z.string().optional().default(''),
});

export type IAddressFormSchema = z.infer<typeof addressSchema>;
